// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KkCfBtEuARFqIz {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
}
.KkCfBtEuARFqIz h1 {
  margin: 20px 0 10px 0;
  font-size: 40px;
}
.KkCfBtEuARFqIz p {
  width: 340px;
  margin: 20px 0 40px 0;
  font-size: 16px;
}
.zipiWQYE16FEjM {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.uZowgcnaiNTYNo {
  position: relative;
  top: 20px;
  right: -90px;
}
.COXsE5_TEiSCbN {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.BcLvk1cDR20bAX {
  width: 340px;
  height: 56px;
  border-radius: 100px;
  background-color: #22a06b;
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}
.BcLvk1cDR20bAX:hover,
.BcLvk1cDR20bAX:active {
  background-color: #1b9663;
  color: #ffffff;
}
.VF0filT26jVYPw {
  margin-top: 32px;
  color: #ffffff;
  font-size: 32px;
}
.VF0filT26jVYPw img {
  margin-right: 15px;
}
.VF0filT26jVYPw:hover {
  background: none;
  color: #ffffff;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `KkCfBtEuARFqIz`,
	"logoContainer": `zipiWQYE16FEjM`,
	"emphasis": `uZowgcnaiNTYNo`,
	"titleContainer": `COXsE5_TEiSCbN`,
	"discoveryButton": `BcLvk1cDR20bAX`,
	"videoButton": `VF0filT26jVYPw`
};
export default ___CSS_LOADER_EXPORT___;
